import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3usc9fbjsg: FaireBrandEntity = {
  token: "b_3usc9fbjsg",
  type: "brand",
  name: "Jacob",
  avatarUrl:
    "https://cdn.faire.com/fastly/570a93d7246650501f7eb3f3e6a1ffb04006e4a1469119a92db383e193bedf60.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d1c6c8f67bdd8a73662726cdcffa4ebd52350321e724f81daf06433ddbe1d6b2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/570a93d7246650501f7eb3f3e6a1ffb04006e4a1469119a92db383e193bedf60.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d1c6c8f67bdd8a73662726cdcffa4ebd52350321e724f81daf06433ddbe1d6b2.png",
  location: "Austin, TX, USA",
  minimumOrderDollars: 90,
  rating: 4.9,
  reviewCount: 28,
  isTopShop: true,
  isInsider: true,
  description:
    "Born from a fight and an awakening for better, Jacob champions the transformative power of clean eating and honest living. Because in health lies hope, and with hope the world is yours.\nThe Jacob Bar is made with just real ingredients and packed with 20g of grass-fed protein. Our fat-base is beef tallow, our sweeteners are honey and dates, and we flavor our bars with real food powders extracts. No gums, additives, or gut-irritating ingredients. \n\nJacob is The World's Cleanest Protein Bar, crafted to help people live better and feel better.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:44.881Z",
    importedBy: "entity-db-cli",
  },
};
